module.exports = __webpack_public_path__ + "static/EWY_Jad-28dbe2a33541ab88e1663051d3bd5ab9.mp4";